import { SubmissionError } from 'redux-form';
import C from '../../../constants';
import { incFlowKey } from "../../../store/actions/display";
import PolyUtil from '../../../util/PolyUtil';
import { setShowAddHistory } from './appDisplay';
import { fetchTenant, handleSetPhoneNumber } from "./tenant";



export const setTenantApplication = (application) => ({
    type: C.SET_TENANT_APPLICATION,
    payload: application
});

export const setRentalHistory = (history) => ({
    type: C.SET_TENANT_RENTAL_HISTORY,
    payload: history
});

export const setEmploymentHistory = (history) => ({
    type: C.SET_TENANT_EMPLOYMENT_HISTORY,
    payload: history
});

export const fetchApplication = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setTenantApplication(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchRentalHistory = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setRentalHistory(data));
    }).then(() => {
        return dispatch(setShowAddHistory(false));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchEmploymentHistory = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/employment-history/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setEmploymentHistory(data));
    }).then(() => {
        return dispatch(setShowAddHistory(false));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleSubmitBasic = (data) => dispatch => {
    const form = PolyUtil.prepData(data);

    return PolyUtil.fetchWrapper('/api/tenant/application/basic/',
        {
            method: 'PATCH',
            body: JSON.stringify(form)
        }
    ).then(() => {
        return dispatch(handleSetPhoneNumber({phone: form.phone}, true));
    }).then(() => {
        return dispatch(fetchTenant());
    }).then(() => {
        return dispatch(incFlowKey("tenant_application"));
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleSubmitAdvanced = (data) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/advanced/',
        {
            method: 'PATCH',
            body: JSON.stringify(data)
        }
    ).then(() => {
        return dispatch(fetchApplication());
    }).then(() => {
        return dispatch(incFlowKey("tenant_application"));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleSubmitVehicle = (data) => dispatch => {
    const form = PolyUtil.prepData(data);

    return PolyUtil.fetchWrapper('/api/tenant/application/vehicle/',
        {
            method: 'PUT',
            body: JSON.stringify(form)
        }
    ).then(() => {
        return dispatch(fetchApplication());
    }).then(() => {
        return dispatch(incFlowKey("tenant_application"));
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleSubmitGuarantorInfo = (guarantor) => dispatch => {
    const data = Object.assign({}, {
        skip_guarantor: false,
        guarantor: PolyUtil.prepData(guarantor),
    });

    return PolyUtil.fetchNoResponse('/api/tenant/application/guarantor/',
        {
            method: 'PATCH',
            body: JSON.stringify(data)
        }
    ).then(() => {
        return dispatch(fetchApplication());
    }).then(() => {
        return dispatch(incFlowKey("tenant_application"));
    }).catch((error) => {
        console.log("Error", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleSubmitBio = (bio) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/bio/',
        {
            method: 'PATCH',
            body: JSON.stringify(bio)
        }
    ).then(() => {
        return dispatch(fetchApplication());
    }).then(() => {
        return dispatch(incFlowKey("tenant_application"));
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleAddRentalHistory = (rental, reference) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/',
        {
            method: 'POST',
            body: JSON.stringify(PolyUtil.prepData(rental))
        }
    ).then((data) => {
        return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/' + data.id + '/reference/',
            {
                method: 'PUT',
                body: JSON.stringify(PolyUtil.prepData(reference))
            });
    }).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleEditRentalHistory = (id, rental, reference) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/' + id + '/', {
        method: "PATCH",
        body: JSON.stringify(PolyUtil.prepData(rental))
    }).then((data) => {
        return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/' + id + '/reference/', {
            method: "PATCH",
            body: JSON.stringify(PolyUtil.prepData(reference))
        });
    }).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleSaveSignature = (dataUrl) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/reference-collection-authorization/', {
        method: "PATCH",
        body: JSON.stringify({
            reference_collection_authorized: true,
            reference_collection_authorization_signature: dataUrl,
        })
    }).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleRemoveRentalHistory = (id) => dispatch => {
    return PolyUtil.fetchNoResponse('/api/tenant/application/rental-history/' + id + '/',
        {method: 'DELETE'}
    ).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleAddEmploymentHistory = (employment) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/employment-history/',
        {
            method: 'POST',
            body: JSON.stringify(PolyUtil.prepData(employment))
        }
    ).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleEditEmploymentHistory = (id, employment) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/employment-history/' + id + '/', {
        method: 'PATCH',
        body: JSON.stringify(PolyUtil.prepData(employment))
    }).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleRemoveEmploymentHistory = (id) => dispatch => {
    return PolyUtil.fetchNoResponse('/api/tenant/application/employment-history/' + id + '/',
        {method: 'DELETE'}
    ).then(() => {
        return dispatch(fetchApplication());
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchApplicationPDF = () => dispatch => {
    return PolyUtil.fetchPDF('/api/tenant/application/pdf/',
        {method: 'GET'},
        'PolyRents_Application'
    ).catch((error) => {
        console.log("Error: ", error);
    });
};



// WEBPACK FOOTER //
// ./src/containers/tenant/actions/application.js